import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import Form from './Form';

export default function ModalForm({
  show, typeView, onSave, onHideModal, currency,
}) {
  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHideModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>Select a Custom Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSave={onSave} onHideModal={onHideModal} typeView={typeView} currency={currency} />
      </Modal.Body>
    </Modal>
  );
}
